<div class="ui-g" *ngIf="!loading && provider_licence.length > 0">
    <!-- <div class="ui-g-12">
        <div class="background_container">
            <div class="table-container mobile_view">
                <div class="table-row" style="padding-left: 20px;padding-right: 20px;">
                    <div class="table-cell" (click)="
                  selectPackage(this.licence_data.api_data.selected_license_id[0])
                ">
                        <div class="plan-name" style="font-weight: 900">
                            {{this.provider_licence[0].name}}
                            <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
                        </div>
                        <div class="price">
                            <span class="plan-name" style="text-decoration: line-through">$1799</span><br />
                            <span class="plan-name" style="font-weight: 900">
                                &nbsp;&nbsp;{{this.provider_licence[0].renderedPrice}}
                            </span>
                            <span class="discount">/{{this.provider_licence[0].expires_after + " "
                                +this.provider_licence[0].expiry_type}}</span><br />

                            <span class="discount" style="color: green">Save 80%</span>
                            <br />
                        </div>
                        <div class="cell-plan-buy egd-color">
                            <div class="cell-plan-buy egd-color">Buy Plan</div>
                        </div>
                    </div>

                    <div class="table-cell" (click)="
                  selectPackage(this.licence_data.api_data.selected_license_id[1])
                ">
                        <div>
                            <button pButton type="button" class="bestseller_btn">
                                <i class="pi pi-star"></i> &nbsp;Recommended
                            </button>
                        </div>
                        <div class="plan-name" style="font-weight: 900">
                            {{this.provider_licence[1].name}}
                            <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
                        </div>
                        <div class="price">
                            <span class="plan-name" style="text-decoration: line-through">$5218</span><br />
                            <span class="plan-name" style="font-weight: 900">
                                &nbsp;&nbsp;{{this.provider_licence[0].renderedPrice}}
                            </span>

                            <span class="discount">/{{this.provider_licence[1].expires_after + " "
                                +this.provider_licence[1].expiry_type}}</span><br />
                            <span class="discount" style="color: green">Save 74%</span>
                            <br />
                        </div>
                        <div class="cell-plan-buy egd-color">
                            <div class="cell-plan-buy egd-color">Buy Plan</div>
                        </div>
                    </div>

                    <div class="table-cell" (click)="
                  selectPackage(this.licence_data.api_data.selected_license_id[2])
                ">
                        <div class="plan-name" style="font-weight: 900">
                            {{this.provider_licence[2].name}}
                            <img src="../../../../assets/images/membership_plans/Icon-awesome-angle-right.png" />
                        </div>
                        <div class="price">
                            <span class="plan-name" style="text-decoration: line-through">$11699</span><br />
                            <span class="plan-name" style="font-weight: 900">
                                &nbsp;&nbsp;{{this.provider_licence[2].renderedPrice}}
                            </span>

                            <span class="discount">/{{this.provider_licence[2].expires_after + " "
                                +this.provider_licence[2].expiry_type}}</span><br />

                            <span class="discount" style="color: green">Save 67%</span>
                            <br />
                        </div>
                        <div class="cell-plan-buy egd-color">
                            <div class="cell-plan-buy egd-color">Buy Plan</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>

<div class="ui-g-12" *ngIf="!loading && provider_licence.length > 0">
    <form class="ui-g-12" accept-charset="UTF-8" #licenseform="ngForm" (submit)="this.submitPackages()">
        <div class="ui-g-12 mobile_view_1">
            <div class="ui-g-12" style="background-color: white ;text-align: center;">
            <p style="font-size: large;">Proceed with plan selection to start your <b>7 days FREE trial</b></p>

                <p class="license_plan_title egd-color">
                    Pricing Plans
                </p>
               
                <div class="license_plan_table1">
                    <div class="ui-g-12 license_plan_header">
                        <div class="ui-g-3 small_screen text-align-center">eGlobalDoctors Benefits:</div>
                        <div class="ui-g-3 text-align-center">{{this.provider_licence[0].name}}</div>
                        <div class="ui-g-3 text-align-center"
                            style="position: relative; background: transparent; z-index: 0">
                            <div class="background-layer" style="z-index: -1; padding: 0px"></div>
                            <div>{{this.provider_licence[1].name}}</div>
                            <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
                                <button pButton type="button" class="bestseller_btn">
                                    <i class="pi pi-star"></i> &nbsp;Recommended
                                </button>
                            </div>
                        </div>
                        <div class="ui-g-3 text-align-center">{{this.provider_licence[2].name}}</div>
                    </div>

                    <div class="ui-g-12 license_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                        <div class="ui-g-3 text-align-center" style="font-weight: 900">
                            Number of users
                        </div>
                        <div class="ui-g-3 text-align-center cell_back">
                            {{this.provider_licence[0].number_of_users}}
                        </div>
                        <div class="ui-g-3 text-align-center">
                            {{this.provider_licence[1].number_of_users}}
                        </div>
                        <div class="ui-g-3 text-align-center">
                            {{this.provider_licence[2].number_of_users}}
                        </div>
                    </div>

                    <div class="ui-g-12 license_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                        <div class="ui-g-3 text-align-center" style="font-weight: 900">
                            Number of Patients
                        </div>
                        <div class="ui-g-3 text-align-center cell_back">
                            {{this.provider_licence[0].number_of_patients}}
                        </div>
                        <div class="ui-g-3 text-align-center">
                            {{this.provider_licence[1].number_of_patients}}
                        </div>
                        <div class="ui-g-3 text-align-center">
                            {{this.provider_licence[2].number_of_patients}}
                        </div>
                    </div>

                    <div class="ui-g-12 license_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                        <div class="ui-g-3 text-align-center" style="font-weight: 900">
                            Email Support
                        </div>
                        <div class="ui-g-3 text-align-center cell_back">
                            <img src="../../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                                alt="tick" />
                        </div>
                        <div class="ui-g-3 text-align-center">
                            <img src="../../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                                alt="tick" />
                        </div>
                        <div class="ui-g-3 text-align-center">
                            <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                                alt="tick" />
                        </div>
                    </div>

                    <div class="ui-g-12 license_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                        <div class="ui-g-3 text-align-center" style="font-weight: 900">
                            Chat Support
                        </div>
                        <div class="ui-g-3 text-align-center cell_back">
                            <img src="../../../../../assets/images/membership_plans/cross_icon.png" alt="tick" />
                        </div>
                        <div class="ui-g-3 text-align-center">
                            <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                                alt="tick" />
                        </div>
                        <div class="ui-g-3 text-align-center">
                            <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                                alt="tick" />
                        </div>
                    </div>

                    <div class="ui-g-12 license_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                        <div class="ui-g-3 text-align-center" style="font-weight: 900">
                            Migration Support
                        </div>
                        <div class="ui-g-3 text-align-center cell_back">
                            <img src="../../../../../assets/images/membership_plans/cross_icon.png" alt="tick" />
                        </div>
                        <div class="ui-g-3 text-align-center">
                            <img src="../../../../../assets/images/membership_plans/cross_icon.png" alt="tick" />
                        </div>
                        <div class="ui-g-3 text-align-center">
                            <img src="../../../../assets/images/membership_plans/Icon awesome-check-circle.png"
                                alt="tick" />
                        </div>
                    </div>

                    <div class="ui-g-12 license_plan_cell" style="border-top: 1px solid #999999; z-index: 1">
                        <div class="ui-g-3 text-align-center" style="font-weight: 900">
                            Plan Validity
                        </div>
                        <div class="ui-g-3 text-align-center cell_back"> {{this.provider_licence[0].expires_after + " "
                            +this.provider_licence[0].expiry_type}}</div>
                        <div class="ui-g-3 text-align-center cell_back"> {{this.provider_licence[1].expires_after + " "
                            +this.provider_licence[1].expiry_type}}</div>
                        <div class="ui-g-3 text-align-center"> {{this.provider_licence[2].expires_after+ " "
                            +this.provider_licence[2].expiry_type}}</div>
                    </div>

                    <div class="ui-g-12 license_plan_cell buy_plan"
                        style="border-top: 1px solid #999999;z-index: 1;padding-top: 60px;padding-bottom: 10px;">
                        <div class="ui-g-3"></div>
                        <div class="ui-g-3 text-align-center cell_back_1">
                            <div>
                                <span style="text-decoration: line-through">$1799</span><br />
                                <span class="discount">&nbsp;&nbsp; {{this.provider_licence[0].renderedPrice}}</span>
                                /{{this.provider_licence[0].expires_after + " " +this.provider_licence[0].expiry_type}}
                                <br />
                                <div class="ui-g-12"></div>
                                <span class="discount" style="color: green">Save 80% </span>
                                <br />
                            </div>
                        </div>
                        <div class="ui-g-3 text-align-center cell_back_1">
                            <div>
                                <span style="text-decoration: line-through">$5218 </span><br />
                                <span class="discount">&nbsp;&nbsp; {{this.provider_licence[1].renderedPrice}}</span>
                                /{{this.provider_licence[1].expires_after + " " +this.provider_licence[1].expiry_type}}
                                <br />
                                <div class="ui-g-12"></div>
                                <span class="discount" style="color: green">Save 74% </span>
                                <br />
                            </div>
                        </div>
                        <div class="ui-g-3 text-align-center cell_back_1">
                            <div>
                                <span style="text-decoration: line-through">$11699 </span><br />
                                <span class="discount">&nbsp;&nbsp; {{this.provider_licence[2].renderedPrice}}</span>
                                /{{this.provider_licence[2].expires_after + " " +this.provider_licence[2].expiry_type}}
                                <br />
                                <div class="ui-g-12"></div>
                                <span class="discount" style="color: green">Save 67% </span>
                                <br />
                            </div>
                        </div>
                    </div>
                    <div class="ui-g-12 license_plan_cell" style="z-index: 1">
                        <div class="ui-g-3"></div>
                        <div *ngFor="let license of this.provider_licence" class="ui-g-3 text-align-center">
                            <p-button pRipple type="button"
                                [styleClass]="isCurrentPackageSelected(license.id) ? 'p-button ui-button-success ui-button-rounded' : 'ui-button-rounded p-button'"
                                [icon]="isCurrentPackageSelected(license.id) ? 'pi pi-check' : 'pi pi-plus'"
                                [label]="isCurrentPackageSelected(license.id) ? 'SELECTED' : 'SELECT'"
                                (click)="selectPackage(license.id)" width="auto" height="auto">
                            </p-button>
                        </div>
                    </div>

                </div>

            </div>
            <div class="ui-g-12 text-center">

                <input type="checkbox" [(ngModel)]="this.terms_and_conditions_checkbox"
                    class="form-check-input" id="terms" name="terms" />
                <label class="form-check-label" for="customCheck1">
                    I agree to the
                    <a role="button" routerLink="../provider-agreement">Terms &amp; Conditions</a>
                </label>

            </div>

            <div class="ui-g-12 text-center">
                <p-button [style]="{ 'margin-right': '5px' }" label="Continue to Payment"
                    [disabled]="!this.licence_data.api_data.selected_license_id || !this.terms_and_conditions_checkbox"
                    styleClass="heading4 p-button-lg ui-button-rounded">
                </p-button>
            </div>
        </div>
    </form>
    
    <div class="ui-g-12" style="text-align: center;">
        <app-error-messages [api_result]="this.licence_data.create_api_result"></app-error-messages>
    </div>
</div>